<template>
  <div class="bom-pc" ref="bomPc">
    <base-form ref="baseFormRef" @updateTable="getData" :seriesNameConfig="seriesNameConfig"> </base-form>

    <replace-material-form ref="replaceMaterialFormRef" @updateTable="getData"></replace-material-form>

    <series-name ref="seriesNameRef" @handleUpdateColumns="getSeriesNameConfig"></series-name>

    <a-space class="export-bom">
      <a-switch checked-children="排序开" un-checked-children="排序关" v-model:checked="sortToogle" />

      <a-button @click="handleUpdateSeriesName" :disabled="!isProjectLeader" size="small">修改系列名称</a-button>

      <a-button @click="exportBom" v-if="props.requestType === null && isProjectLeader" type="primary"
        size="small">导出BOM表</a-button>
    </a-space>

    <template v-for="(item, index) in materialClassification" :key="index">
      <div style="margin-bottom: 10px; padding-right: 30px" class="df both-side">
        <div class="material-classification">
          {{ item.label }}
        </div>
        <a-button @click="handleUpdateBom(null, 'add', item.value)" type="primary" v-if="
          (props.requestType === null && isProjectLeader) ||
          props.requestType !== null
        ">新增</a-button>
      </div>

      <div style="padding-right: 20px;">

        <a-table :data-source="bomData[item.value].tableData" :expanded-row-keys="bomData[item.value].expandedRowKeys"
          bordered :pagination="false" :columns="columns" rowKey="id" style="margin-bottom: 30px; "
          @expandedRowsChange="expandedRowsChange($event, item.value)" @expand="expand"
          :scroll="{ x: 'calc(100vw - 60px)', y: 'calc(100vh - 275px)' }" :rowClassName="(record, index) =>
            record.materialCode.indexOf('P') !== -1
              ? 'semi-finish-product'
              : null
            " :customRow="sortToogle ? customRow : null">
          <!-- 排序 -->
          <template #sort>
            <HolderOutlined />
          </template>

          <template #inspect="{ record }">
            <div v-if="record.inspect" :class="[record.inspect === '抽检' ? 'spot-check' : 'inspect']">
              {{ record.inspect }}
            </div>
          </template>

          <template #action="{ record }">
            <div class="df action" v-if="
              (props.requestType === null && isProjectLeader) ||
              props.requestType !== null
            ">
              <a-tooltip placement="top" v-if="record.materialCode.indexOf('P') !== -1">
                <template #title>
                  <span>添加</span>
                </template>
                <PlusSquareOutlined class="action-icon" @click="handleUpdateBom(record, 'addchild', item.value)" />
              </a-tooltip>

              <span v-else class="action-icon" style="margin-right: 28px;">

              </span>

              <a-tooltip placement="top">
                <template #title>
                  <span>修改</span>
                </template>
                <EditOutlined class="action-icon" @click="handleUpdateBom(record, 'edit', item.value)" />
              </a-tooltip>
              <a-tooltip placement="top">
                <template #title>
                  <span>替换物料版本</span>
                </template>
                <img src="@/assets/img/page/replace.png" class="action-icon"
                  @click="handleUpdateBom(record, 'replace', item.value)" />
              </a-tooltip>
              <a-tooltip placement="top">
                <template #title>
                  <span>删除</span>
                </template>
                <DeleteOutlined class="action-icon danger" @click="handleDeleteRecord(record)" />
              </a-tooltip>
            </div>
          </template>
        </a-table>
      </div>


    </template>
  </div>
</template>

<script>
import {
  computed,
  defineComponent,
  inject,
  nextTick,
  onMounted,
  reactive,
  ref,
  watch,
} from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { Toast } from "@/utils";
import {
  deleteBOMData,
  getBOMDataList,
  exportBOMData,
  updateBOMDataList,
} from "@/request/view/project";
import {
  materialClassification,
  bomColumns,
} from "@/views/rdmanagement/components/bom/serve/options";
import {
  DeleteOutlined,
  EditOutlined,
  PlusSquareOutlined,
  HolderOutlined,
} from "@ant-design/icons-vue";
import { showModal } from "@/views/repairprogress/serve/modal";
import {
  handleUpdateDragTarget,
  checkLevel,
  getUpdateSortList,
  dragTarget,
} from "@/views/rdmanagement/components/bom/all/drag";
import { getSeriesNameByProject } from '@/views/rdmanagement/components/bom/components/series';
import baseForm from "@/views/rdmanagement/components/bom/components/baseForm.vue";
import replaceMaterialForm from '@/views/rdmanagement/components/bom/components/replaceMaterial.vue'
import seriesName from "@/views/rdmanagement/components/bom/components/seriesName.vue";

export default defineComponent({
  components: {
    baseForm,
    replaceMaterialForm,
    DeleteOutlined,
    EditOutlined,
    PlusSquareOutlined,
    seriesName,
    HolderOutlined,
  },
  props: {
    requestType: String,
    bomType: String,
  },
  setup(props) {
    const route = useRoute();

    const { id } = useStore().state.user.user;

    const isProjectLeader = computed(() => route.query.userId == id);

    const sortToogle = ref(false);

    const baseFormRef = ref();

    const replaceMaterialFormRef = ref();

    const bomPc = ref();
    // 表格数据
    const bomData = reactive({
      // 主物料
      主物料: {
        tableData: [],
        expandedRowKeys: [],
      },
      // 包材
      包材: {
        tableData: [],
        expandedRowKeys: [],
      },
      // 配件
      配件: {
        tableData: [],
        expandedRowKeys: [],
      },
      // 随机文件
      随机文件: {
        tableData: [],
        expandedRowKeys: [],
      },
      // 辅料
      辅料: {
        tableData: [],
        expandedRowKeys: [],
      },
    });

    // 导出BOM表
    const exportBom = () => {
      exportBOMData({
        projectLifeCycleId: route.query.projectId,
      }).then((res) => {
        const link = document.createElement("a");
        const blob = new Blob([res], { type: "application/vnd.ms-excel" });
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", `${route.query.projectName}BOM表.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        Toast("success", "下载成功", 3);
      });
    };

    // 重置数据
    const resetBomData = (updateKey) => {
      updateKey.forEach((key) => {
        bomData[key].tableData.length = 0;
        bomData[key].expandedRowKeys.length = 0;
      });
    };

    // 展开行
    const setExpandRow = (data, updateKey) => {
      // 递归数据 把children中的id置入控制展开的数组中
      function iteExpandId(list, expandedRowKeys) {
        list.forEach((item) => {
          expandedRowKeys.push(item.id);

          if (item.children && item.children.length > 0) {
            iteExpandId(item.children, expandedRowKeys);
          }
        });
      }

      updateKey.forEach((key) => {
        if (data[key]) {
          iteExpandId(data[key], bomData[key].expandedRowKeys);
        }
      });
    };

    // 表格赋值
    const setBomData = (data, updateKey) => {
      updateKey.forEach((key) => {
        if (data[key]) {
          bomData[key].tableData.push(...data[key]);
        }
      });
    };

    // 获取需要更新的类型
    const getUpdateBomKey = (type) => {
      const defaultKey = [];

      if (type) {
        return [type];
      }

      Object.keys(bomData).forEach((key) => {
        defaultKey.push(key);
      });

      return defaultKey;
    };

    let content = ref(null);

    //定义的searchKeyword点击事件
    const searchKeyword = (dom) => {

      //g 全局匹配模式。这里的 g 指的是 global
      let reg = new RegExp(route.query.materialCode, "g");

      //将匹配出的地方替换成加了个class的span标签的${route.query.materialCode}
      //然后再将这replace过的innerHTML赋值给newContent

      if (content.value.indexOf(route.query.materialCode) === -1) return;


      const rowList = Array.from(dom.querySelectorAll('tr'));

      rowList.forEach((tr) => {
        if (tr.childNodes[1].childNodes[2].data === route.query.materialCode) {
          tr.childNodes[1].style.color = 'red';
          // tr.childNodes[1].add = 'red';
          tr.childNodes[1].setAttribute('class', 'replace-material')
        }

      });
      //定位替换元素span的class
      let X = document.getElementsByClassName("replace-material")[0].offsetLeft;
      let Y = document.getElementsByClassName("replace-material")[0].getBoundingClientRect().top - 200;

      //然后滚动到那个地方
      //这个document.getElementsByClassName("right-content")[0]
      //替换成自己要滚动的元素
      document.getElementsByClassName("bom-pc")[0].scrollTo(X, Y);
    }

    const findMaterialCodeLocation = () => {
      nextTick(() => {
        Array.from(document.getElementsByTagName("table")).forEach((dom) => {
          content.value = dom.innerHTML;
          searchKeyword(dom);
        });
        content.value = null;
      });
    };

    const getData = (type) => {
      // 获取需要更新的类型
      const updateKey = getUpdateBomKey(type);
      // 重置数据
      resetBomData(updateKey);

      getBOMDataList({
        projectLifeCycleId: route.query.projectId,
        type: props.requestType,
      }).then((res) => {
        if (res.code === 200 && res.message === "成功") {
          // 表格赋值
          setBomData(res.data, updateKey);
          // 展开行
          setExpandRow(res.data, updateKey);
          if (route.query.type === 'materialLinkBom') {
            // 寻找物料位置
            findMaterialCodeLocation()
          }
        }
      });
    };

    const handleUpdateBom = (record, type, materialClassification) => {
      console.log('click')
      const title = type === "edit" ? "修改" : "添加";

      if (type === 'replace') {
        replaceMaterialFormRef.value.showModal({
          title: "替换物料",
          type,
          data: record,
          materialClassification,
        });
        return
      }

      baseFormRef.value.showModal({
        title,
        type,
        data: record,
        materialClassification,
      });
    };

    // 展开行
    const expandedRowsChange = (expandedRows, type) => {
      // console.log(expandedRows, type);
    };
    // 点击展开图标
    const expand = (expanded, record) => {
      // { 物料类型 记录id }
      const { bomFrameName, id } = record;
      // 展开行数组 无赋值空
      const expandedRowKeys = bomData[bomFrameName]
        ? bomData[bomFrameName].expandedRowKeys
        : null;
      // 展开推入数组
      if (expandedRowKeys && expanded) {
        expandedRowKeys.push(id);
        // 关闭从数组中删除
      } else if (expandedRowKeys && !expanded) {
        const deleteIndex = expandedRowKeys.findIndex((f) => f == id);
        expandedRowKeys.splice(deleteIndex, 1);
      } else {
        Toast("warning", "展开错误", 3);
      }
    };

    // 删除记录
    const handleDeleteRecord = (record) => {
      showModal({
        title: "提示",
        success: () => {
          deleteBOMData([record.id])
            .then((res) => {
              let type = res.code === 200 ? "success" : "warning";
              Toast(type, res.message, 3);
              getData(record.bomFrameName);
            })
            .catch((err) => { });
        },
        toastText: "确认删除？",
      });
    };

    const activeKey = inject("activeKey");
    const dataBaseKey = inject("dataBaseKey");

    watch(
      () => dataBaseKey,
      (val) => {
        if (val.value === props.bomType) {
          getData(null);
        }
      },
      {
        deep: true,
      }
    );

    watch(
      () => activeKey,
      (val) => {
        if (val.value === "BOM表") {
          getData(null);
        }
      },
      {
        deep: true,
      }
    );

    watch(
      () => route,
      (val) => {
        if (val.path === "/rdprojectlayout") {
          getData(null);
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    // 确认修改排序
    const checkUpdataSort = (text) => {
      return new Promise((resolve, reject) => {
        showModal({
          title: "提示",
          success: () => {
            resolve();
          },
          toastText: text,
        });
      });
    };

    const recordImg = new Image();

    recordImg.src = require("../../../../../assets/img/page/bom.png");

    const customRow = (record, index) => {
      return {
        style: {
          cursor: record.isFrame ? "grab" : "",
        },
        onMouseenter: (event) => {
          if (!record.isFrame) return;
          event.target.draggable = true;
        },
        // 开始拖拽
        onDragstart: (event) => {
          if (!record.isFrame) return;
          // 阻止冒泡
          event.stopPropagation();

          event.dataTransfer.setData("text/plain", event.target.id);
          event.dataTransfer.setDragImage(recordImg, 10, 10);
        },
        // 拖拽进入的节点
        onDragenter: (event) => {
          const table = bomData[record.bomFrameName];
          handleUpdateDragTarget(table.tableData, event);
        },
        // 鼠标松开
        onDragend: (event) => {
          if (!record.isFrame) return;
          // 阻止冒泡
          event.stopPropagation();
          const table = bomData[record.bomFrameName];
          try {
            const { list, startIndex, endIndex } = checkLevel(
              table.tableData,
              record
            );

            const direction = startIndex < endIndex ? "下方" : "上方";

            const text = `将${record.materialName}拖拽至${dragTarget.value.materialName}${direction}`;

            checkUpdataSort(text).then((res) => {
              const updateList = getUpdateSortList(list, startIndex, endIndex);
              const type = record.bomFrameName;
              updateBOMDataList(updateList).then((res) => {
                const toastType = res.code === 200 ? "success" : "warning";
                Toast(toastType, res.message, 3);
                getData(type);
              });
            });
          } catch (error) {
            console.log(error);
            Toast("warning", "请拖拽数据至同一层", 3);
          }
        },
        onMouseleave: (event) => {
          if (!record.isFrame) return;
          event.target.draggable = false;
        },
      };
    };

    const expandIcon = (props) => {
      console.log(props, "opop");
    };

    // 系列名称

    const seriesNameRef = ref();

    const seriesNameConfig = reactive({
      id: null,
      projectLifeCycleId: null,
      seriesFourName: null,
      seriesOneName: null,
      seriesThreeName: null,
      seriesTwoName: null
    });

    const columns = reactive([...bomColumns]);


    const setColumnsSeriesName = () => {
      const updateColumnsKey = {
        seriesOneName: 'seriesOneQuantity',
        seriesTwoName: 'seriesTwoQuantity',
        seriesThreeName: 'seriesThreeQuantity',
        seriesFourName: 'seriesFourQuantity',
      };
      const updateSeriesName = (key, name) => {
        const item = columns.find((f) => f.dataIndex === key);
        item.title = name;
      };

      ['seriesOneName', 'seriesTwoName', 'seriesThreeName', 'seriesFourName'].forEach(key => {
        if (seriesNameConfig[key]) updateSeriesName(updateColumnsKey[key], seriesNameConfig[key]);
      });
    }

    const getSeriesNameConfig = async () => {
      const res = await getSeriesNameByProject(route.query.projectId);
      if (res && res.code == 200 && res.data) {
        Object.keys(seriesNameConfig).forEach(key => {
          seriesNameConfig[key] = res.data[key];
        });
        setColumnsSeriesName();
      }
    };

    const handleUpdateSeriesName = () => {
      seriesNameRef.value.showModal({
        visible: true,
        ...seriesNameConfig
      });
    };

    getSeriesNameConfig();

    return {
      seriesNameRef,
      replaceMaterialFormRef,
      handleUpdateSeriesName,
      getSeriesNameConfig,
      props,
      bomPc,
      sortToogle,
      customRow,
      exportBom,
      isProjectLeader,
      bomData,
      baseFormRef,
      columns,
      seriesNameConfig,
      materialClassification,
      expand,
      getData,
      expandedRowsChange,
      handleDeleteRecord,
      handleUpdateBom,
      expandIcon,
    };
  },
});
</script>

<style lang="less" scoped>
.bom-pc {
  overflow-y: scroll;
  height: calc(100vh - 140px);
  position: relative;

  .export-bom {
    position: fixed;
    right: 20px;
    top: 80px;
  }

  .series-name {
    position: fixed;
    right: 420px;
    top: 80px;
    font-size: 20px;
    font-weight: bold;
  }

  .material-classification {
    font-size: 24px;
    font-weight: bold;
  }

  :deep(.ant-table-row-expand-icon) {
    float: right;
  }

  :deep(.ant-table-row-collapsed) {
    transform: rotateZ(90deg);
  }

  :deep(.ant-table-row-expanded) {
    transform: rotateZ(90deg);
  }

  :deep(.ant-table-row-collapsed::after) {
    content: '>';
  }

  :deep(.ant-table-row-expanded::after) {
    content: '<';
  }

  :deep(.semi-finish-product)> :nth-child(1) {
    background-color: #ffd965;
  }

  :deep(.ant-table-row-level-0)> :nth-child(1) {
    background-color: #ffd965;
  }

  :deep(.ant-table-row-level-1)> :nth-child(1) {
    background-color: #b7ff65;
  }

  :deep(.ant-table-row-level-2)> :nth-child(1) {
    background-color: #65faff;
  }

  :deep(.ant-table-thead)>tr>th {
    background-color: #70ad46;
  }

  :deep(.ant-table-tbody)>tr :nth-child(13) {
    padding: 0;
  }


  .inspect {
    background: #ff6c0d;
  }

  .action-icon {
    width: 14px;
    height: 14px;
  }
  .action {
    :deep(span) {
      margin-right: 15px;
    }
    img {
      margin-right: 15px;
    }
  }

  .spot-check {
    background: #ffff00;
  }
}
</style>
